import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";

// const ZONES = [
//   "India",
//   "GCC",
//   "MENA",
//   "Europe",
//   "USA",
//   "AsiaPacific",
//   "Others"
// ];

// const LOBS = [
//   "All",
//   "Women",
//   "MSME",
//   "Agriculture",
//   "BlueCollar",
//   "Education",
//   "BehaviourOS",
//   "PurpleDoor",
//   "FoundHer",
//   "Think5Whys",
// ];

// const AREAS = [
//   "All",
// ];

const PDCoordinators = ({
  currentTheme = {
    card: "bg-gray-800",
    text: "text-white",
    border: "border-gray-700",
  },
}) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState?.user?._id;
  const userCode = authState?.user?.think5whyscode;

  const [selectedZone, setSelectedZone] = useState("India");
  const [selectedLOB, setSelectedLOB] = useState("All");
  const [selectedArea, setSelectedArea] = useState("All");

  const [zones, setZones] = useState([]);
  const [lobs, setLobs] = useState([]);
  const [areas, setAreas] = useState([]);

  const [coordinators, setCoordinators] = useState([]);
  const [loading, setLoading] = useState(false);

  const cardClass = `
    ${currentTheme.card}
    ${currentTheme.text}
    border
    ${currentTheme.border}
    rounded-2xl
    p-5
  `;

  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedCoordinator, setSelectedCoordinator] = useState(null);
  const [agreed, setAgreed] = useState(false);
  const [contactType, setContactType] = useState(null);

  const fetchPDCoordinators = async () => {
    try {
      setLoading(true);
      const config = {
        url: `/faq/pdcoordinators?zone=${selectedZone}&lob=${selectedLOB}&area=${selectedArea}`,
        method: "GET",
        headers: { Authorization: authState.token },
      };

      fetchData(config)
          .then((response) => {
            if (response.success) {
                setCoordinators(response.data || []);
                setZones(response.filters?.zones || []);
                setLobs(response.filters?.lobs || []);
                setAreas(response.filters?.areas || []);
            }
        })
        .catch(() => {
          setCoordinators([]);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPDCoordinators();
  }, [selectedZone, selectedLOB, selectedArea]);

  return (
    <div className="space-y-2 bg-gray-900 px-6 py-2 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
      <div className={cardClass}>
        <h2 className="text-sm text-cyan-200">
          🤝 PurpleDoor Coordinators
        </h2>

        <p className="text-[10px] text-gray-100 opacity-75 mt-2">
          Connect with verified PurpleDoor Coordinators for onboarding, Ai Signals, FuelStash activities, 
          Digital Boutique Advisor opportunities, and ecosystem guidance.
        </p>
      </div>
      <h2 className='text-start text-sm lg:text-lg text-cyan-200'>Global Zones</h2>
      <div className="flex flex-wrap gap-2">
        {zones.map((zone) => (
          <button
            key={zone}
            onClick={() => setSelectedZone(zone)}
            className={`
              w-fit p-2
              rounded-md
              text-xs
              border
              transition-all
              leading-none
              ${
                selectedZone === zone
                  ? "bg-purple-600 text-white border-purple-600"
                  : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
              }
            `}
          >
            🌍 {zone}
          </button>
        ))}
      </div>
      <h2 className='text-start text-sm lg:text-lg text-cyan-200'>Segment</h2>
      <div className="flex flex-wrap gap-2">
        {lobs.map((lob) => (
          <button
            key={lob}
            onClick={() => setSelectedLOB(lob)}
            className={`
              w-fit p-2
              rounded-md
              text-xs
              border
              transition-all
              leading-none
              ${
                selectedLOB === lob
                  ? "bg-pink-600 text-white border-pink-600"
                  : "bg-gray-100 text-gray-700 border-gray-300"
              }

            `}
          >
            💼 {lob}
          </button>
        ))}
      </div>
      <h2 className='text-start text-sm lg:text-lg text-cyan-200'>Area</h2>
      <div className="flex flex-wrap gap-2 border-b border-gray-400 rounded-lg py-2 mb-2">
        {areas.map((area) => (
          <button
            key={area}
            onClick={() => setSelectedArea(area)}
            className={`
              w-fit p-2
              rounded-md
              text-xs
              border
              transition-all
              leading-none
              ${
                selectedArea === area
                  ? "bg-cyan-600 text-white border-cyan-600"
                  : "bg-gray-100 text-gray-700 border-gray-300"
              }

            `}
          >
            📍 {area}
          </button>
        ))}
      </div>

      <div className={cardClass}>
        <div className="flex justify-between items-center">
          <h3 className="text-xs font-semibold text-white">
            {selectedZone} Coordinators
          </h3>

          <span className="text-xs opacity-70 text-gray-100">
            {coordinators.length} Available
          </span>
        </div>
      </div>

      {loading && (
        <div className="text-center text-xs text-cyan-300 py-4">
          Loading Coordinators...
        </div>
      )}

      <div className="space-y-3">
        {coordinators.map((coordinator) => (
          <div
            key={coordinator.id}
            className={cardClass}
          >
            <div className="flex flex-col lg:flex-row lg:justify-between gap-4">
              <div>
                <div className="font-semibold text-xs">
                  {coordinator.name}
                </div>
                <div className="text-xs text-gray-100 opacity-75 mt-1">
                  📍 {coordinator.city},{" "}
                  {coordinator.state ||
                    coordinator.country}
                </div>
              </div>
              <div className="flex gap-2 items-start">
                <button
                  onClick={() => {
                    setSelectedCoordinator(coordinator);
                    setContactType("whatsapp");
                    setShowContactModal(true);
                  }}
                  className="
                    w-32
                    flex
                    items-center
                    justify-center
                    gap-1
                    px-1 py-1
                    rounded-lg
                    bg-green-600
                    text-white
                    text-xs
                    whitespace-nowrap
                  "
                >
                  💬 Chat
                </button>
                <button
                  onClick={() => {
                    setSelectedCoordinator(coordinator);
                    setContactType("email");
                    setShowContactModal(true);
                  }}
                  className="
                    w-32
                    flex
                    items-center
                    justify-center
                    gap-1
                    px-1 py-1
                    rounded-md
                    bg-blue-600
                    text-white
                    text-xs
                    whitespace-nowrap
                  "
                >
                  📧 Email
                </button>
              </div>
              {showContactModal && (
                <div className="fixed inset-0 z-50 bg-black/50 flex text-gray-100 items-center justify-center p-4">
                  <div className="bg-white rounded-2xl p-5 max-w-md w-full">
                    <h3 className="font-semibold text-sm">
                      🤝 PurpleDoor Contact Access
                    </h3>

                    <p className="text-xs mt-3 text-gray-600">
                      PurpleDoor Coordinators are available to support learners,
                      parents, creators, Digital Boutique Advisors, and ecosystem members.
                    </p>

                    <div className="mt-4 space-y-3">
                      <label className="flex gap-2 text-xs text-gray-100">
                        <input
                          type="checkbox"
                          checked={agreed}
                          onChange={(e) => setAgreed(e.target.checked)}
                        />
                        <span className="text-gray-600 text-[10px] ">
                          I am contacting for a genuine PurpleDoor-related purpose and
                          agree to communicate respectfully.
                        </span>
                      </label>
                    </div>

                    <div className="flex gap-2 mt-2 text-gray-100">
                      <button
                        onClick={() => {
                          setShowContactModal(false);
                          setAgreed(false);
                        }}
                        className={`
                          flex-1 py-1 text-xs rounded-lg text-white
                          ${agreed
                            ? "bg-purple-600"
                            : "bg-gray-400 cursor-not-allowed"}
                        `}
                      >
                        Cancel
                      </button>

                      <button
                        disabled={!agreed}
                        onClick={() => {
                          if (contactType === "whatsapp") {
                            window.open(
                              `https://wa.me/${selectedCoordinator.mobileNumber}`,
                              "_blank"
                            );
                          } else {
                            window.location.href =
                              `mailto:${selectedCoordinator.emailId}`;
                          }

                          setShowContactModal(false);
                          setAgreed(false);
                        }}
                        className={`
                          flex-1 py-1 text-xs rounded-lg text-white
                          ${agreed
                            ? "bg-purple-600"
                            : "bg-gray-400 cursor-not-allowed"}
                        `}
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {coordinators.length === 0 && (
        <div className={cardClass}>
          <div className="text-center text-xs lg:text-sm text-yellow-100 opacity-70">
            This zone is currently open for expansion. If you're interested in becoming a PurpleDoor Coordinator, please contact <span className="font-semibold">babita[at]think5whys.com</span>.
          </div>
        </div>
      )}
    </div>
  );
};

export default PDCoordinators;